import {
  CSV,
  FORBIDDEN_DELIMITER_CHARS_REGEX,
  FORBIDDEN_QUOTED_DELIMITER_CHARS_REGEX,
  TXT,
} from '../constants';
import { ExportFormat } from '../types';

const isForbiddenDelimiter = (
  delimiter: string,
  format: ExportFormat
): boolean =>
  format === CSV || format === TXT
    ? FORBIDDEN_QUOTED_DELIMITER_CHARS_REGEX.test(delimiter)
    : FORBIDDEN_DELIMITER_CHARS_REGEX.test(delimiter);

export default isForbiddenDelimiter;
